import React, { FC } from 'react';

import { useI18n } from '@/scenarios/home/hooks/useI18n';
import { InfoBlockTitle } from '@/shared/components/InfoBlockTitle/InfoBlockTitle';
import { InfoBlockSubtitle } from '@/shared/components/InfoBlockSubtitle/InfoBlockSubtitle';

import styles from './HomeShowcaseHeader.module.css';

interface HomeShowcaseHeaderProps {
    type?: 'base' | 'extra';
}

export const HomeShowcaseHeader: FC<HomeShowcaseHeaderProps> = ({ type = 'base' }) => {
    const i18n = useI18n();
    const title =
        type === 'extra'
            ? i18n('home__showcase_header_title_extra')
            : i18n('home__showcase_header_title_base');
    const subtitle =
        type === 'extra'
            ? i18n('home__showcase_header_subtitle_extra')
            : i18n('home__showcase_header_subtitle_base');

    return (
        <header className={styles.root}>
            <InfoBlockTitle>{title}</InfoBlockTitle>
            <InfoBlockSubtitle>{subtitle}</InfoBlockSubtitle>
        </header>
    );
};
